import Swal from 'sweetalert2';
import { VideoService } from '../../services';
import { thumbDraft, preview, thumbnail, step, menu } from '../../store';
import ThumbDraftService from '@/services/thumbdraft';
import { MENU, STEP } from '../../types/common';
export async function restoreImageDraft(draft) {
    menu.set(MENU.THUMBNAILS);
    Swal.fire({
        title: 'Restoring Draft',
        didOpen: () => {
            Swal.showLoading();
        },
        allowOutsideClick: () => !Swal.isLoading(),
        allowEscapeKey: () => !Swal.isLoading(),
        allowEnterKey: () => !Swal.isLoading()
    });
    const videoService = new VideoService();
    const videoResponse = await videoService.getVideo(draft.video.id, true);
    draft.project.video = videoResponse;
    thumbDraft.set({
        ...draft,
        currentCloudDraftId: draft.id
    });
    thumbnail.set({
        type: draft.type,
        ...draft.project,
        video: videoResponse
    });
    preview.set({
        ...draft.metadata,
        restored: true
    });
    if (draft.currentStep === STEP.ADMIN || draft.currentStep === null || draft.currentStep == STEP.CHOOSE_VIDEO) {
        step.update(STEP.CHOOSE_TEMPLATE);
    }
    else {
        step.update(draft.currentStep);
    }
    setTimeout(() => {
        Swal.close();
    }, 1000);
}
export async function deleteDraft(draft) {
    return new Promise(resolve => {
        Swal.fire({
            title: 'Are you sure you want to delete this image?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete it'
        })
            .then(async (result) => {
            if (result.isConfirmed) {
                const ds = new ThumbDraftService();
                if (result.isConfirmed) {
                    ds.delete(draft.id)
                        .then(() => {
                        Swal.fire({
                            position: 'bottom-end',
                            icon: 'success',
                            title: 'Draft successfully deleted!',
                            showConfirmButton: false,
                            timer: 1500,
                            toast: true
                        });
                        resolve(true);
                    })
                        .catch(error => {
                        resolve(false);
                    });
                    return;
                }
                resolve(false);
            }
        })
            .catch(error => {
            resolve(false);
        });
    });
}
